module.exports = __webpack_public_path__ + "img/KI.b8e96516.png";